<script>
export default {
  name: 'MidiMonitorDeviceSelect',

  components: {},

  props: {
    midiInputs: {
      type: Array,
      required: true,
    },
    selectedInputId: {
      type: String,
      default: null,
    },
    midiError: {
      type: String,
      default: null,
    },
    midiAccess: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:selectedInputId', 'refresh'],
};
</script>

<template>
  <div class="midi-monitor-panel__device-select">
    <!-- Show dropdown whenever there are inputs (hardware or virtual WiFi). -->
    <template v-if="midiInputs.length > 0">
      <label class="midi-monitor-panel__select-label" for="midi-device-select">Device</label>
      <select
        id="midi-device-select"
        :value="selectedInputId"
        class="select select-sm midi-monitor-panel__select"
        @change="$emit('update:selectedInputId', $event.target.value)"
      >
        <option v-for="input in midiInputs" :key="input.id" :value="input.id">
          {{ input.name }}
        </option>
      </select>
    </template>
    <template v-else-if="midiError">
      <span class="midi-monitor-panel__error">{{ midiError }}</span>
    </template>
    <template v-else>
      <span class="midi-monitor-panel__no-devices">No MIDI inputs detected</span>
    </template>

    <button
      v-if="!midiError && midiAccess"
      class="midi-monitor-panel__icon-btn"
      title="Refresh MIDI devices"
      @click="$emit('refresh')"
    >
      ↻
    </button>
  </div>
</template>
